import { IGetDatabasesParams } from '../requests/GetDatabasesRequest';
import { IGetTablesParams } from '../requests/GetTablesRequest';

export function forceIsEmbeddedToFalse(
  params: IGetDatabasesParams | IGetTablesParams
): IGetDatabasesParams | IGetTablesParams {
  if (params.filter) {
    // Casted to nay here because the params interfaces don't expose the fields or value properties that we need to change and add later down in the function
    const castedParams: any = params;
    const index = params.filter.clauses.findIndex((value) => {
      const castedValue: any = value;
      return castedValue.field === 'isEmbedded';
    });

    // check if embedded already exists and set to false if it does; otherwise add it to the clauses list
    if (index !== -1) {
      castedParams.filter.clauses[index].value = false;
      params = {
        ...castedParams,
      };
    } else {
      params.filter.clauses.push({
        operator: 'eq',
        field: 'isEmbedded',
        value: false,
      } as any);
    }
  }
  return params;
}
